/* KOKO — pop-up de bienvenue (sections/koko-bienvenue.liquid), 03/11/2026.
   Ouverture : une fois par visiteur (localStorage « kkBienvenue », date de la dernière ouverture ; remontrée après data-freq jours),
   jamais pendant l'écran d'ouverture (html.kin-on), jamais par-dessus le bandeau cookies de Shopify (#shopify-pc__banner : on attend
   la réponse du visiteur, événement visitorConsentCollected ou bandeau disparu), ni par-dessus un tiroir ouvert ou une saisie en cours.
   ?bienvenue dans l'adresse : ouverture forcée (pour la régler). Dans l'éditeur de thème : ouverte quand la section est sélectionnée. */
(function () {
  var KEY = 'kkBienvenue';
  var reduit = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  function lire() { try { return parseInt(localStorage.getItem(KEY), 10) || 0; } catch (e) { return 0; } }
  function noter() { try { localStorage.setItem(KEY, String(Date.now())); } catch (e) {} }

  function ouvrir(d) {
    if (!d || d.open) return;
    d.classList.remove('kbn--out');
    try { d.showModal(); } catch (e) { d.setAttribute('open', ''); }
    var box = d.querySelector('.kbn__in');
    if (box) { try { box.focus({ preventScroll: true }); } catch (e) {} }
    requestAnimationFrame(function () { requestAnimationFrame(function () { d.classList.add('kbn--on'); }); });
    if (d.dataset.design !== '1') noter();
  }
  function fermer(d) {
    if (!d || !d.open || d.classList.contains('kbn--out')) return;
    d.classList.remove('kbn--on');
    d.classList.add('kbn--out');
    setTimeout(function () {
      d.classList.remove('kbn--out');
      try { d.close(); } catch (e) { d.removeAttribute('open'); }
    }, reduit ? 0 : 280);
  }

  function brancher(d) {
    if (!d || d._kbn) return;
    d._kbn = true;
    d.addEventListener('click', function (e) {
      if (e.target === d) { fermer(d); return; }                 /* clic sur le fond sombre */
      if (e.target.closest('[data-kbn-close]')) { fermer(d); }
    });
    d.addEventListener('cancel', function (e) { e.preventDefault(); fermer(d); }); /* Échap : fermeture animée */
  }

  /* ---------- éditeur de thème ---------- */
  var d0 = document.querySelector('dialog.kbn');
  if (!d0) return;
  if (d0.dataset.design === '1') {
    brancher(d0);
    var trouver = function (id) { return document.querySelector('dialog.kbn[data-section="' + id + '"]'); };
    document.addEventListener('shopify:section:select', function (e) { var d = trouver(e.detail.sectionId); if (d) { brancher(d); ouvrir(d); } });
    document.addEventListener('shopify:section:deselect', function (e) { var d = trouver(e.detail.sectionId); if (d) fermer(d); });
    document.addEventListener('shopify:section:load', function (e) { var d = trouver(e.detail.sectionId); if (d) { brancher(d); ouvrir(d); } });
    return;
  }
  brancher(d0);

  /* ---------- sur le site ---------- */
  var force = /[?&]bienvenue(=|&|$)/.test(location.search);
  var jours = parseInt(d0.dataset.freq, 10) || 30;
  var derniere = lire();
  if (!force && derniere && Date.now() - derniere < jours * 864e5) return;
  var delai = force ? 800 : (parseInt(d0.dataset.delai, 10) || 4) * 1000;

  function bandeauVisible() {
    var b = document.getElementById('shopify-pc__banner');
    if (!b || !b.getClientRects().length) return false;
    var cs = getComputedStyle(b);
    return cs.display !== 'none' && cs.visibility !== 'hidden' && parseFloat(cs.opacity) > 0.05;
  }
  /* (04/11/2026) seulement les tiroirs et fenêtres de Concept, par leur balise : le panneau du tiroir panier (div#MiniCart-…) porte
     l'attribut open en permanence, et un ancien « [open]:not(details) » le trouvait toujours : la pop-up ne s'ouvrait jamais sur le site. */
  var TIROIRS = 'cart-drawer[open],menu-drawer[open],search-drawer[open],drawer-element[open],share-drawer[open],back-in-stock-drawer[open],x-modal[open],modal-element[open]';
  var vuBandeau = 0;
  function occupe() {
    var h = document.documentElement;
    if (h.classList.contains('kin-on') || h.classList.contains('kin-out')) return true;   /* écran d'ouverture */
    if (bandeauVisible()) { vuBandeau = Date.now(); return true; }                          /* bandeau cookies */
    if (Date.now() - vuBandeau < 1600) return true;                                         /* on laisse respirer après la réponse */
    if (document.querySelector(TIROIRS)) return true;                                        /* tiroir ouvert (panier, menu, recherche…) */
    var a = document.activeElement;
    if (a && /^(INPUT|TEXTAREA|SELECT)$/.test(a.tagName)) return true;                     /* saisie en cours */
    return false;
  }
  var essais = 0;
  function tenter() {
    if (d0.open) return;
    if (occupe()) {
      /* bandeau cookies sans réponse, tiroir ouvert, saisie : on repasse chaque seconde, et on abandonne au bout de 10 minutes
         (la pop-up n'a pas été vue : elle sera proposée à la prochaine visite) */
      if (essais++ < 600) setTimeout(tenter, 1000);
      return;
    }
    ouvrir(d0);
  }
  function lancer() { setTimeout(tenter, delai); }
  if (document.readyState === 'complete') lancer();
  else window.addEventListener('load', lancer, { once: true });
})();
